// Generated by ts-to-zod
import { z } from 'zod';

export const estimatedErrorRateTimeseriesDataSchema = z.object({
  date: z.string(),
  errorRateEstimate: z.number().nullable(),
  isQualityEstimate: z.boolean(),
  windowDocumentCount: z.number(),
});

export const documentAutomationTimeSeriesDataSchema = z.object({
  date: z.string(),
  automatedCount: z.number(),
  nonAutomatedCount: z.number(),
  touchedCount: z.number(),
  touchlessCount: z.number(),
});

export const documentBlockerSchema = z.object({
  blocker: z.string(),
  documentCount: z.number(),
  granularity: z.union([z.literal('annotation'), z.literal('datapoint')]),
  exampleAnnotationIds: z.array(z.number()),
});

export const automationProjectionsPayloadSchema = z.object({
  fields: z.array(
    z.object({
      schemaId: z.string(),
      errorRateLimit: z.number(),
    })
  ),
});

export const automationProjectionsQuerySchema = z.object({
  excludeBlockers: z.array(
    z.union([z.literal('error_message'), z.literal('extension')])
  ),
});

export const automationTargetSchema = z.object({
  automationRateTarget: z.number(),
  errorRateTarget: z.number(),
  datapointAutomationTargets: z.array(
    z.object({
      schemaId: z.string(),
      errorRateTarget: z.number(),
      errorRateLimit: z.number().nullable(),
      confidenceThreshold: z.number(),
    })
  ),
  type: z.union([
    z.literal('legacy_thresholds'),
    z.literal('automation_assistant_v1'),
  ]),
  datetime: z.string(),
});

export const saveAutomationTargetPayloadSchema = automationTargetSchema.omit({
  datetime: true,
});

export const datapointStatisticsSchema = z.object({
  schemaId: z.string(),
  blockedDocumentCounts: z.record(z.number()),
  estimatedErrorRate: z.number().nullable(),
  confidenceThreshold: z.number().nullable(),
  blockers: z.array(documentBlockerSchema),
  isQualityEstimate: z.boolean(),
});

export const automationInsightsSchema = z.object({
  documentAutomationRate: z.number(),
  documentAutomationTimeseries: z.array(documentAutomationTimeSeriesDataSchema),
  datapointStatistics: z.array(datapointStatisticsSchema),
  estimatedErrorRate: z.number().optional().nullable(),
  documentBlockers: z.array(documentBlockerSchema),
  isAuroraQueue: z.boolean().optional(),
  estimatedErrorRateTimeseries: z.array(estimatedErrorRateTimeseriesDataSchema),
});

export const projectionInsightsSchema = automationInsightsSchema
  .omit({ estimatedErrorRate: true, estimatedErrorRateTimeseries: true })
  .and(
    z.object({
      estimatedErrorRate: z.number(),
      estimatedErrorRateTimeseries: z
        .array(estimatedErrorRateTimeseriesDataSchema)
        .nullable(),
    })
  );

export const automationProjectionsSchema = z.object({
  baseline: projectionInsightsSchema,
  projections: z.array(projectionInsightsSchema),
  totalDocumentCount: z.number(),
  usedDocumentCount: z.number(),
});
